export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver al campo"])},
          "edit_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspección de calidad"])},
          "total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])},
          "legend": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Leyenda"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to crop field"])},
          "edit_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
          "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality inspection"])},
          "total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])},
          "legend": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legend"])}
        }
      }
    }
  })
}